<ion-spinner></ion-spinner>
<span class="busy-panel--content">{{message}}</span>
